import { render, staticRenderFns } from "./service-locations-general-card-edit.vue?vue&type=template&id=8c41921a&scoped=true&"
import script from "./service-locations-general-card-edit.vue?vue&type=script&lang=js&"
export * from "./service-locations-general-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-general-card-edit.vue?vue&type=style&index=0&id=8c41921a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c41921a",
  null
  
)

export default component.exports